import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Profile',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Profile',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Profile',
    column_type: 'datetime',
  },
  name: {
    model_name: 'Profile',
    column_type: 'string',
  },
  email: {
    model_name: 'Profile',
    column_type: 'string',
  },
  phone: {
    model_name: 'Profile',
    column_type: 'string',
  },
  gender: {
    model_name: 'Profile',
    column_type: 'enum',
  },
  first_name: {
    model_name: 'Profile',
    column_type: 'string',
  },
  last_name: {
    model_name: 'Profile',
    column_type: 'string',
  },
  whatsapp: {
    model_name: 'Profile',
    column_type: 'string',
  },
  instagram: {
    model_name: 'Profile',
    column_type: 'string',
  },
  avatar: {
    model_name: 'Profile',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  avatar_with_audio: {
    model_name: 'Profile',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
